import { useGridApiRef } from '@mui/x-data-grid-pro';
import type { GridApiPro } from '@mui/x-data-grid-pro';
import type { GridApiCommunity } from '@mui/x-data-grid/internals';
import type { MutableRefObject } from 'react';
import { useAnonymousCustomersReport } from '../../../../hooks/requests/use-anonymous-customers-report';
import { useSearchWithSearchParams } from '../../../../hooks/use-search-with-search-params';
import { ReportHeader } from '../../reports-components/ReportHeader';
import { ReportTable } from '../../reports-components/ReportTable';
import { REPORT_TYPES } from '../../reports-page/reports-page-types/report-type';
import { AnonymousCustomersReportTable } from './anonymous-customers-report-table/AnonymousCustomersReportTable';
import { Box } from '@mui/material';

type AnonymousCustomersReportContentProps = {
  reportId?: string;
};

export const AnonymousCustomersReportContent: React.FC<AnonymousCustomersReportContentProps> = ({
  reportId,
}) => {
  const { data: anonymousCustomersReportData, isLoading } = useAnonymousCustomersReport(reportId);
  const [searchText, setSearchText] = useSearchWithSearchParams();
  const { report, creationDate } = anonymousCustomersReportData;
  const apiRef = useGridApiRef();

  return (
    <>
      <ReportHeader reportData={report} creationDate={creationDate} />
      <ReportTable
        apiRef={apiRef as MutableRefObject<GridApiCommunity>}
        title="Anonymous Customers Report"
        placeholder="Enter customer name..."
        exportCsvFileName="Anonymous customers report"
        reportCreationDate={creationDate}
        onSearch={(searchValue) => setSearchText(searchValue)}
        reportType={REPORT_TYPES.ANONYMOUS_CUSTOMERS}
      >
        <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <AnonymousCustomersReportTable
            isLoading={isLoading}
            filter={searchText ?? undefined}
            apiRef={apiRef as MutableRefObject<GridApiPro>}
            rows={report}
          />
        </Box>
      </ReportTable>
    </>
  );
};
